import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'hourly_no_tech',
    emoji: '🎬',
    name: 'Hourly (Studio Only)',
    description: 'No technician - minimum 2 hours',
    price: 1600000,
    duration: '2 hours min',
    features: ['2 x 4K cameras', '2 studio mics', '3-point lighting', 'Neutral backdrop']
  },
  {
    id: 'hourly_with_tech',
    emoji: '⭐',
    name: 'Hourly + Technician',
    description: 'With dedicated technician - minimum 2 hours',
    price: 2400000,
    duration: '2 hours min',
    popular: true,
    features: ['2 x 4K cameras', '2 studio mics', '3-point lighting', 'Dedicated technician', 'Real-time monitoring']
  },
  {
    id: 'half_day',
    emoji: '📦',
    name: 'Half Day Pack',
    description: '4 hours with technician - Record 1 full episode',
    price: 4500000,
    duration: '4 hours',
    features: ['2 x 4K cameras', '2 mics', 'Dedicated technician', 'Raw files same day', 'Water & coffee']
  },
  {
    id: 'full_day',
    emoji: '🏆',
    name: 'Full Day Pack',
    description: '8 hours with technician - Record 2-3 episodes',
    price: 8000000,
    duration: '8 hours',
    features: ['2 x 4K cameras', '2 mics', 'Dedicated technician all day', 'Files organized by episode', 'Partner restaurant -10%']
  }
];

const addons = [
  { id: 'extra_camera', name: 'Extra camera (3rd angle)', price: 200000, description: 'Per hour' },
  { id: 'extra_mics', name: '2 extra microphones', price: 150000, description: 'Per hour' },
  { id: 'teleprompter', name: 'Teleprompter', price: 100000, description: 'Per hour' },
  { id: 'green_screen', name: 'Green screen', price: 150000, description: 'Per hour' },
  { id: 'rgb_lighting', name: 'RGB custom lighting', price: 100000, description: 'Per hour' },
  { id: 'basic_edit', name: 'Basic edit (cuts only)', price: 1500000, description: 'Per episode' },
  { id: 'pro_edit', name: 'Pro edit (animations, titles, music)', price: 2500000, description: 'Per episode' },
  { id: 'reel_1', name: '1 Reel (60s)', price: 500000 },
  { id: 'reels_3', name: 'Pack 3 Reels', price: 1200000 },
  { id: 'reels_5', name: 'Pack 5 Reels', price: 1800000 },
  { id: 'transcription', name: 'Transcription', price: 400000, description: 'Per episode' },
  { id: 'subtitles', name: 'Integrated subtitles (FR or EN)', price: 600000, description: 'Per episode' },
  { id: 'thumbnail', name: 'YouTube thumbnail', price: 300000 }
];

const customFields = [
  { id: 'num_people', label: 'Number of people in the studio', type: 'number', placeholder: '2' },
  { id: 'content_type', label: 'What will you be recording?', type: 'text', placeholder: 'Podcast, interview, course...' }
];

export default function StudioRentalBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="studio_rental"
      serviceTitle="Studio Rental"
      serviceSubtitle="Professional podcast and video studio"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/studio-rental"
    />
  );
}
